<template>
  <div class="main">
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 80%"
    >
      OTHER DETAILS
    </div>
    <div class="card-body">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>4</span>
            </div>
            <!-- pickup comments starts-->
            <div class="pickupinstructions box">
              <h4>
                {{ pickupinstructionsmessage }}
                <span
                  href="#"
                  class="pa3 btn"
                  style="color: #00587d; padding: 0"
                  @click.stop="showQuestion = true"
                >
                  <v-icon color="#ffffff">info</v-icon>
                </span>

                <v-dialog v-model="showQuestion" max-width="500px">
                  <div class="dialog">
                    <v-icon
                      @click="showQuestion = false"
                      style="border-radius: 0.8em; background: #6dbe45"
                      >close</v-icon
                    >
                    <h5>{{ pickupquestionmessage }}</h5>
                  </div>
                </v-dialog>
              </h4>
              <textarea
                v-model="bind_PickupInstruction"
                cols="20"
                rows="4"
                placeholder="Add comments or questions here..."
                class="pa1"
                style="
                  border: 2px solid #c7c7c7;
                  color: black;
                  background-color: white;
                  border-radius: 3px;
                  width: 80%;
                "
                @change="maintainSessionStorage()"
              ></textarea>
              <br />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- pickup comments ends-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "PickupOtherDetails",
  data() {
    return {
      showQuestion: false,
      pickupinstructionsmessage:
        "If you have any questions regarding the pick-up process, please enter them here (if none, please leave blank):",
      pickupquestionmessage:
        "Upon arrival at the depot, you'll provide the release number that we will send to you by email. The lift operator will bring you the next container off the stack that matches your purchase criteria. If you have any other questions about how the process works, please ask them below.",
    };
  },
  computed: {
    ...mapGetters({
      pickupInstruction: types.PICKUP_INSTRUCTIONS,
      prepickup: types.PREPICKUPANSWERS,
    }),
    bind_PickupInstruction: {
      get() {
        return this.pickupInstruction;
      },
      set(value) {
        this.updatePickupInstruction(value);
      },
    },
  },
  methods: {
    ...mapActions({
      updatePickupInstruction: types.ACTIONS_UPDATE_PICKUP_INSTRUCTIONS,
    }),
    maintainSessionStorage() {
      const prepickup = JSON.stringify(this.prepickup);
      sessionStorage.setItem("prepickup", prepickup);
    },
  },
};
</script>

<style scoped>
.question_cards {
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 20px;
  padding-left: 3px;
  padding-right: 3px;
  overflow: hidden;
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

.box {
  color: #00587d;
}

h5,
textarea {
  font-size: 14px;
  font-weight: normal;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

input[type="radio"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

@media only screen and (min-width: 760px) {
  textarea {
    width: 100%;
  }
}
</style>
